<!-- 分享 -->
<template>
    <el-dialog title="渠道分享" class="openShare" :visible.sync="dialogTableVisible" width="304px">
        <div class="content">
            <img :src="code" alt="">
            <p class="downloadCode" @click="download">下载二维码</p>
        </div>
    </el-dialog>
</template>

<script>
import {urlToQRCode, downloadImage} from 'common/js/tools'
export default {
    data() {
        return {
            dialogTableVisible: false,
            code: ''
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open(courseurl) {
            this.code = urlToQRCode(courseurl)
            this.dialogTableVisible = true
        },
        download() {
            downloadImage(this.code, '渠道二维码')
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .openShare {
        .content {
            text-align: center;
            .downloadCode {
                cursor: pointer;
                color: #409EFF;
                font-size: 14px;
                padding-top: 16px;
            }
        }
    }
</style>